module.exports = __webpack_public_path__ + "tf.svg?f3cb00d839fe254e9352e724cc3f1e59";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/tf.svg
// module id = 1142
// module chunks = 27